import { Link } from 'react-router-dom';

export default function SoldCta() {
  return (
    <section className="py-20 bg-[#1A2332] text-white">
      <div className="container mx-auto px-4 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
          <i className="ri-radar-line text-[#E8B84B]"></i>
          <span className="text-sm font-medium">The next one won't last either</span>
        </div>

        <h2 className="font-oswald text-4xl md:text-5xl font-bold mb-4">
          These Sold Because We Priced Them{' '}
          <span className="text-[#E8B84B]">Honestly.</span>
        </h2>
        <p className="text-xl text-white/80 mb-4 max-w-2xl mx-auto leading-relaxed">
          No inflated sticker prices. No "market adjustment" nonsense. Just fair cars at fair prices — 
          which is exactly why they move fast.
        </p>
        <p className="text-base text-white/60 mb-10 max-w-xl mx-auto">
          If you want to be the one who gets the deal instead of the one who reads about it here, 
          now's a good time to browse what's still available.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/inventory"
            className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
          >
            <i className="ri-car-line text-xl"></i>
            See What's Still Available
          </Link>
          <Link
            to="/deal-radar"
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            <i className="ri-notification-line text-xl"></i>
            Alert Me When One Lands
          </Link>
        </div>

        <p className="mt-8 text-sm text-white/70 italic">
          Deal Radar is free. We'll ping you the moment something matching your criteria hits the lot.
        </p>
      </div>
    </section>
  );
}
